"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRedirectFromUrl = void 0;
var URL_PARAM_NAME = 'redirect_url';
var getRedirectFromUrl = function getRedirectFromUrl() {
  var urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(URL_PARAM_NAME);
};
exports.getRedirectFromUrl = getRedirectFromUrl;
//# sourceMappingURL=url.js.map